import type { FaireProductEntity } from "../../entity_types/product";

export const p_gnd99g4vw4: FaireProductEntity = {
  token: "p_gnd99g4vw4",
  type: "product",
  name: "Tahitian 15.75 oz. Hi Ball",
  brandName: "Hospitality Glass",
  imageUrl:
    "https://cdn.faire.com/fastly/1a876524693e896d1b24bfed4c60bf169a1f62975455159d136e2cc6877761ee.jpeg",
  priceDollars: 8.6,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/22255ec01b6063498142712f464e8195d3c0edb4be71cb3d49d77738ac1be22d.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
